import React from 'react';

const CommissionType = ({
    label,
    type
}) => {
    return (
        <div className={`rt--commission-type-pill type-${type}`}>
            {label}
        </div>
    )
}

export default CommissionType;
